import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { IDayOfWeekList } from '../../../Pages/Pricing/IPricing';

export const DayOfWeekSlicer = createSlice({
  name: 'DayOfWeek',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<IDayOfWeekList[]>,
  reducers: {
    getDayOfWeek: (state, action) => {
      state.isLoading = true;
    },
    successGetDayOfWeek: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureGetDayOfWeek: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
  },
});

export const { getDayOfWeek, failureGetDayOfWeek, successGetDayOfWeek } =
  DayOfWeekSlicer.actions;

export default DayOfWeekSlicer.reducer;
